module.exports = __webpack_public_path__ + "fonts/NormaticaDisplay-Demo.a16d6b75.woff";